import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { getPressList } from '../../networkCalls'

import FotterMain from '../BaseComponents/FotterMain'
import Header from '../BaseComponents/Header'
import LoadingCellFullPage from '../LoadingCell/LoadingCellFullPage'
import parse from 'html-react-parser';
const PressReleaseListing = () => {
  const [loading, setLoading] = useState(false);
  const [resultData, setResultData] = React.useState([]);

  const pullPressReleaseApi = () => {
    setLoading(true);
    getPressList().then((res) => {
      setLoading(false);
      switch (res.data.status) {
        case 1:
          setResultData(res?.data?.pressList)
          //setErrMessage('');
          return true;
        case 0:
          //setErrMessage(res.data.msz);
          break;
        default:
          return;
      }
    })
  }

  useEffect(() => {
    pullPressReleaseApi();
  }, []);
  const toTop = () => {
    window.scrollTo(0, 0);
  }
  useEffect(() => {
    toTop();
  }, []);
  return (
    <>
      <Header />
      {loading ? <><LoadingCellFullPage /></> : <>
        <div className='innerpagebg pt-5 pb-5'>
          <div className='container mb-4'>
            <div className='row'>
              <div className='col-12  m-auto'>
                <div className="align-items-center text-center">
                  <h4 className='d-inline-block m-0 fw-bold text-uppercase'>
                    <span className='txtred'>Press</span> <span className='txtdgray'>Release</span>
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div className='container'>
            {resultData && resultData?.length > 0 ? <>
              <div className='row'>
                {resultData && resultData?.map(data =>
                  <div key={data?.dataId} className='col-lg-4 col-12'>
                    <div className="post-card mb-4">
                      <div className="post-card__image" style={{maxHeight:'250px', minHeight:'250px', overflow:'hidden'}}><Link to={`/press-release/${data?.slug}`}>
                        <img alt="" className='img-fluid' src={data?.image} /></Link></div>
                      <div className="post-card__content">
                        <div className="post-card__category"><span className='txtlgeay'>{data?.date}</span></div>
                        <div className="post-card__title mb-2">
                          <h2 ><Link to={`/press-release/${data?.slug}`} className='txtdgray'>{data?.title}</Link></h2>
                        </div>
                        <div className="post-card__date f12 mt-2"><Link to={`/press-release/${data?.slug}`} className='txtred'>MORE...</Link></div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </> : <>
              <div className='row'>
                <div className='col-lg-12'>
                  <div className='card text-center p-4'>
                    No Records Found
                  </div>
                </div>
              </div>
            </>}
          </div>
        </div>
      </>}
      <FotterMain />
    </>
  )
}

export default PressReleaseListing